import { render, staticRenderFns } from "./CreateSocialBookingSlot.vue?vue&type=template&id=3b01b1ff&scoped=true&"
import script from "./CreateSocialBookingSlot.vue?vue&type=script&lang=js&"
export * from "./CreateSocialBookingSlot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b01b1ff",
  null
  
)

export default component.exports